import { render, staticRenderFns } from "./DescCom.vue?vue&type=template&id=04fad514&scoped=true&"
import script from "./DescCom.vue?vue&type=script&lang=js&"
export * from "./DescCom.vue?vue&type=script&lang=js&"
import style0 from "./DescCom.vue?vue&type=style&index=0&id=04fad514&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fad514",
  null
  
)

export default component.exports